/* eslint-disable import/prefer-default-export */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
/**
 * Utility functions for chat and response handling
 */

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Converts content to JSON markdown format
 */
export const getJsonMarkdown = (content: unknown): string => {
  try {
    if (typeof content === 'string') {
      return content;
    }
    return `\`\`\`json\n${JSON.stringify(content, null, 2)}\n\`\`\``;
  } catch {
    return String(content);
  }
};
